<template>
  <v-layout>
      <div id="miao" class="completeList mb-0 mt-4">

    <v-toolbar flat color="third" class="pl-0 toolbarLocations">
       <v-tooltip bottom>
        <v-btn v-if="this.$store.getters['auth/partnerId'] !== -1" class="mr-2" icon slot="activator" @click="triggerCreationProcess">
          <v-icon>add</v-icon>
        </v-btn>
        <span> {{$translate('CREATE_EVENT')}}</span>
      </v-tooltip>
      <v-divider class="mx-3" inset vertical></v-divider>
      <h3 text-xs-center class="ml-4">{{$translate('MY_EVENTS')}}({{events.length}})</h3>
      <v-spacer></v-spacer>
      <v-divider class="mx-3" inset vertical></v-divider>
      {{sort ? $translate('SORT') + ": A-Z" : $translate('SORT') + ": Z-A"}}
      <v-btn icon @click="reverseArrayOfEvents">
        <v-icon>{{sort ? "arrow_drop_up" : "arrow_drop_down"}}</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="text-xs-center">
      <v-list v-if="paginatedEvents.length > 0 && listToggle" class="scrollList2 pl-2">
        <template v-for="(item, index) in paginatedEvents">
          <div :key="index">
            <v-divider :inset="item.inset"></v-divider>
            <v-list-tile class="showOver">
              <!-- <v-list-tile-avatar>
                <img :src="item.image">
              </v-list-tile-avatar> -->
              <v-flex xs6>
                <v-list-tile-content>
                  <v-list-tile-title>{{item.name}}</v-list-tile-title>
                </v-list-tile-content>
              </v-flex>
              <v-spacer></v-spacer>
              <div class="align-right">
                <v-tooltip bottom>
                  <v-btn small round slot="activator" class="primary" @click="selectEvent(item)">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <span>{{$translate('EDIT_EVENT')}}</span>
                </v-tooltip>
                <v-tooltip  bottom>
                  <v-btn small round slot="activator" @click="showDeleteConfirmation(item)">
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                  <span>{{$translate('DELETING_EVENT')}}</span>
                </v-tooltip>
              </div>
            </v-list-tile>
          </div>
        </template>
      </v-list>
      <v-list v-else class="scrollList2 pl-2">
        <v-layout align-space-around justify-space-around row fill-height>
          <v-icon justify-space-around disabled color="primary" style="font-size: 100px;">ballot</v-icon>
        </v-layout>
      </v-list>
    </div>
    <v-pagination
      class="pagination mt-0"
      total-visible="7"
      v-model="page"
      :length="nPages"
      @input="selectPage"
      @next="changePage('next')"
      @previous="changePage('previous')"
    ></v-pagination>
  </div>
   <v-dialog class="eventCreationDialog" v-model="typeOfEventCreation" width="800px">
      <v-card>
        <v-toolbar dark color="primary">
         <v-layout column>
        <v-card-title class="testerbest">
          Type of creation
        </v-card-title>
        <v-card-title>
          Please choose on of the following options to continue.
        </v-card-title>
         </v-layout>
        </v-toolbar>
       <v-card-text>
         <v-layout ml-4 justify-center column fill-height>
          <v-card class="eventWizardScreen" @click="creationTypeSelected('standard')">
            <v-layout row>
           <v-avatar class="ml-4 mt-1 mr-1">
             <v-icon color="primary" x-large>access_time</v-icon>
           </v-avatar>
            <v-card-title class="headline">Standard creation</v-card-title>
            </v-layout>
            <v-card-text class="cardTexter">
              Quickly create a standard event.
            </v-card-text>
          </v-card>
          <v-card @click="creationTypeSelected('advanced')" class="eventWizardScreen">
            <v-layout row>
           <v-avatar class="ml-4 mt-1 mr-1">
             <v-icon color="primary" x-large>settings_applications</v-icon>
           </v-avatar>
            <v-card-title class="headline">Advanced creation </v-card-title>
            </v-layout>
            <v-card-text class="cardTexter">
<!--              <h3><i>Not available yet..</i></h3>-->
<!--              <v-divider></v-divider>-->
              To access all the possibilities for a event, choose for 'Advanced creation'. All types of events are accesible.
            </v-card-text>
          </v-card>
          </v-layout>
       </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="typeOfEventCreation=false">Close</v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
  </v-layout>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import Events_Batchgroups from "./Events_Batchgroups";
import _ from "lodash";
import { ui_helpers } from "../../shared/ui_helpers";
import { mapGetters } from "vuex";
import Events_Editing from "@/components/Events/Events_Editing";
import EventWizard_Main from "@/components/EventWizard_Main";
import Events_Messages from "@/components/Events/Events_Messages";
import Events_main_old from "@/components/Events/Events_main_old";
import { setTimeout } from "timers";
import CreateEventObject2 from "@/objects/CreateEventObject2.js";

export default {
  name: "Events_main",
  components: {
    "Events-Batchgroups": Events_Batchgroups,
    "Events-Editing": Events_Editing,
    "Events-Messages": Events_Messages,
    EventWizard_Main,
    Events_main_old
  },
  mixins: [ui_helpers],
  props: {
    properties: Object
  },
  computed: {
    ...mapGetters({
      tabIdAccountManagement: "getTabIdAccountManagement",
      events: "getEvents",
    })
  },
  data() {
    return {
      typeSelected: "",
      sort: false,
      active: null,
      advancedSelected: false,
      standardSelected: false,
      sort: false,
      tabsNumber: 3,
      paginatedEvents: [],
      elementXpage: 12,
      page: 1,
      nPages: 1,
      listToggle: false,
      typeOfEventCreation: false,
    };
  },
  watch: {
    tabIdAccountManagement: function(n, o) {
      this.active = "tab-" + n;
    },
    events: function(newE, oldE) {
      this.events.forEach(element => {
        element.selected = false;
        this.page = 1;

      });
      this.recountEventPage();

      if (newE !== oldE) {
        this.sortEvents();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.sortEvents()
    }, 500);
      this.recountEventPage();
    this.active = "tab-" + this.tabIdAccountManagement;

    // let page = "Events_main"
    // this.$store.commit("setCurrentComponent", page);
  },
  created() {
    window.EventBus.listen("TypeOfEventCreationTrigger", this.TypeOfEventCreationTrigger);
  },
  beforeDestroy() {
        this.events.forEach((e, index) => {
      this.$set(e, "selected", false);
    });
    let page = "Events_main";
    this.$store.commit("setCurrentComponent", page);
    window.EventBus.removeListener("TypeOfEventCreationTrigger", this.TypeOfEventCreationTrigger);
  },
  methods: {
    selectEvent(item) {
      const payload = {
        EventId: Number(item.eventId),
        LanguageTagId: this.$store.getters.getUserLanguage
      };
      dssRequest.doRequest(
        response => {
          console.log("The call for 'getEventDetailsV2' on - Events_main.vue was successful", response);
          this.$store.commit("setChosenEvent", response.data);
          this.eventDetail = CreateEventObject2._createArrayWithObjects(
            response.data
          );
          window.EventBus.fire("dataForComponent", this.eventDetail);
          window.EventBus.fire("selectEvent", { eventId: this.eventDetail.eventId });
          // if (this.$store.getters['auth/partnerId'] !== -1) {
          //   if (item.type == "Standard") {
          //     this.showComponents({
          //       main: "EventWizard_Main",
          //       side: "EventView_Overview"
          //     });
          //   } else {
          //     this.showComponents({
          //       main: "Events_main_old",
          //       side: "EventView_Overview"
          //     });
          //   }
          // } else {
          this.showComponents({
            main: "Events_main_old",
            side: "EventView_Overview"
          });
          // }
        },
        error => {
          console.log(
            "The call for 'getEventDetails' on - Dashboard.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GED_004');
        },
        "getEventDetailsV2",
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false
      );
    },
    showDeleteConfirmation(item) {
      const payload = {
        EventId: Number(item.eventId),
        LanguageTagId: this.$store.getters.getUserLanguage
      };
      dssRequest.doRequest(
        response => {
          console.log("The call for 'getEventDetails' on - Events_main.vue - was successful", response);
          let eventDetail = CreateEventObject2._createArrayWithObjects(response.data);
          this.deleteText = this.$translate("DELETE_EVENT_NOK");
          this.disableUpdate = true;
          eventDetail.memberOf.forEach(e => {
            if (
              e.grantType === "OWNER" &&
              e.accountId == this.$store.getters.getCurrentAccountId
            ) {
              this.deleteText = this.$translate("DELETE_EVENT");
              this.disableUpdate = false;
            }
          });
          window.EventBus.fire('showDeleteEvent', {item: item, text: this.deleteText, disable: this.disableUpdate});
        },
        error => {
          console.log("The call for 'getEventDetails' on - Events_main.vue - was not successful", error);
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GED_004');
        },
        "getEventDetailsV2",
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false
      );
    },
    creationTypeSelected(type) {
      this.typeSelected = type;
      this.typeOfEventCreation = false;
      window.EventBus.fire("setTypeOfEventCreation", this.typeSelected);
      this.createNewEvent();
    },
    TypeOfEventCreationTrigger() {
       if (this.$store.getters["auth/userLevel"] == 6) {
       this.typeOfEventCreation = true;
        }
    },
    reverseArrayOfEvents(){
      this.$store.commit("setEvents",this.events.reverse());
      this.sort = !this.sort
    },
    sortEvents() {
      function compare(a, b) {
        // Use toUpperCase() to ignore character casing
              const bandA = a.name.toUpperCase();
              const bandB = b.name.toUpperCase();

              let comparison = 0;
              if (bandA > bandB) {
                comparison = 1;
              } else if (bandA < bandB) {
                comparison = -1;
              }
              return comparison;
            }
        this.$store.commit("setEvents", this.events.sort(compare));
        this.sort = !this.sort;
        this.$store.commit("setSortLocationOrder", this.sort);
      this.$store.commit("setEventFilterName", "");
      this.listToggle = true;
    },
    triggerCreationProcess() {
              if (this.$store.getters["auth/userLevel"] == 6) {
             this.typeOfEventCreation = true;
              } else {
                this.createNewEvent();
              }

    },
     createNewEvent() {
      if (this.typeOfEventCreation == false) {
        if (this.typeSelected === "standard") {
          this.$store.commit("setChosenEvent", {});
          this.showComponents({
            main: "EventWizard_Main",
            side: "EventView_Overview"
          });
        } else {
          this.showComponents({
            main: "EventCreation",
            side: "EventView_Overview"
          });
        }
      } else {
        this.triggerCreationProcess();
      }
    },
    selectPage() {
      this.recountEventPage();
    },
    changePage() {
      this.recountEventPage();
    },
    recountEventPage() {
      this.nPages = Math.ceil(this.events.length / this.elementXpage);
      let start = (this.page - 1) * this.elementXpage;
      this.paginatedEvents = [];
      this.paginatedEvents = this.events.filter(
        (e, i) => i >= start && i < start + this.elementXpage
      );
    },
  },
};
</script>

<style lang="scss", scoped>
.eventWizardScreen {
  min-width: 50em;
  display: inline-block;
  cursor: pointer;
  padding-bottom: 2em;
  margin-top: 3em;
  margin-bottom: 1em;
  border-radius: 3em !important;
  max-height: 500px !important;
  max-width: 700px !important;
}

.testerbest{
font-size: 25px;
margin-bottom: -5%;
}

.cardTexter{
  max-width: 75%;
margin-left: 10%;
}

.tab_container {
  height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.tabs_style {
  border-radius: 2em;
}

.pagination {
  position: relative;
  bottom: 0;
}

.toolbarLocations{
  max-width: 98%;
}

.class1 {
  background: #000000;
  background-color: #000000;
  color: #000000;

    padding-bottom: 2em;
  margin-top: 3em;
  margin-bottom: 1em;
  border-radius: 3em !important;
  max-height: 500px !important;
  max-width: 700px !important;
}

.class2 {
  background: #000000;
  padding-bottom: 2em;
  margin-top: 3em;
  margin-bottom: 1em;
  border-radius: 3em !important;
  max-height: 500px !important;
  max-width: 700px !important;
}

.scrollList2 {
  height: 70vh;
  max-width: 98%;
  overflow-x: hidden;
  overflow-y: auto;
}
.showOver:hover {
  background-color: lightgray;;
}
.completeList {
  margin-left: 5% !important;
  min-width: 90% !important;
}
.eventWizardScreen:hover {
  background-color: lightgrey;
  transform: scale(1.05);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
</style>
